import script from "./employee-salary-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-salary-modal.vue?vue&type=script&setup=true&lang=js"

import "./employee-salary-modal.vue?vue&type=style&index=0&id=2b8acb40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b8acb40"]])

export default __exports__